import { MaxWidthSettingEnum } from "../../types";

const OPTIONS: string[] = Object.values(MaxWidthSettingEnum);

export const ensureMaxWidthSetting = (
  option?: unknown,
  fallback: MaxWidthSettingEnum = MaxWidthSettingEnum.wide,
) => {
  if (typeof option !== "string") return fallback;

  if (OPTIONS.includes(option)) {
    return option;
  }

  return fallback;
};
